import { Box, useMediaQuery } from '@mui/material';
import {
  IStyles,
  deserify,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../reduxStore/reduxHooks';
import {
  ASSESSMENT_VIEW,
  HOMEWORK_PERFORMANCE,
} from '../../../../routeHandling/RoutesNomenclature';
import { OverviewBox } from '../../../../components/OverviewBox';
import { StudentPerformanceGrid } from '../../../../components/StudentPerformanceGrid';
import { AssessmentPageType } from '../../ClickerAssessmentManage';
import { interactionEvent } from '../../../Auth/auth.events';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import { MarkingSchemeEnum } from '@protos/learning_management/lms.db_pb';

const styles: IStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(34) },
  },
};

interface IProps {
  pageType: AssessmentPageType;
}
export const CAEndedHwRightPanel = (props: IProps) => {
  const { pageType } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { current_assessmemt_classStats, selected_assessment_id } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const { clicker_assessment_info } = deserify(
    useAppSelector((state) => state.clickerAssessment)
  );
  const attemptNumber =
    clicker_assessment_info?.selected_attempt?.attemptNumber;
  const cardOnClick = async (studentId: string) => {
    const queryParams = new URLSearchParams();
    if (attemptNumber !== undefined) {
      queryParams.append('attemptNumber', String(attemptNumber));
    } else {
      queryParams.append('isBestAttempt', String(true));
    }
    const queryString = queryParams.toString();
    const path = `${HOMEWORK_PERFORMANCE}/${studentId}${
      queryString ? `?${queryString}` : ''
    }`;
    navigate(path);
    await interactionEvent({
      context: 'Student_list',
      name: 'STUDENT_PERFORMANCE',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };
  const isMultiSubjectAssessment = current_assessmemt_classStats?.assessment
    ?.subjects
    ? current_assessmemt_classStats.assessment.subjects.length > 1
    : false;

  const isJeeMarkingScheme =
    current_assessmemt_classStats?.assessment?.markingSchemeType ===
    MarkingSchemeEnum.MARKING_SCHEME_JEE;
  return (
    <Box sx={styles.root}>
      {!isMobile && (
        <OverviewBox
          assessmentTargetDate={
            current_assessmemt_classStats?.assessment?.assessmentTargetDate
          }
          difficultyLevel={
            current_assessmemt_classStats?.assessment?.difficultyLevel
          }
          numberOfQuestions={
            current_assessmemt_classStats?.assessment?.assessmentContentInfo
              ?.numberOfQuestions
          }
          viewAssessmentCTA={() => navigate(`${ASSESSMENT_VIEW}/ended`)}
        />
      )}

      <StudentPerformanceGrid
        className={`${current_assessmemt_classStats?.assessment?.class}${current_assessmemt_classStats?.assessment?.section}`}
        studentPerformanceInfoList={
          current_assessmemt_classStats?.studentPerformanceInfo
        }
        cardMaxMarks={current_assessmemt_classStats?.assessment?.maxMarks}
        cardSubmissionType={
          current_assessmemt_classStats?.assessment?.submissionType
        }
        cardOnClickHandler={cardOnClick}
        statusInfo={clicker_assessment_info?.statusInfo}
        pageType={pageType}
        assignedStudentCount={
          current_assessmemt_classStats?.assignedStudentsCount
        }
        studentSubmissionCount={
          current_assessmemt_classStats?.studentsSubmissionCount
        }
        attemptNumber={attemptNumber}
        isBestAttempt={attemptNumber !== undefined ? false : true}
        assessmentId={selected_assessment_id}
        showBulkReportButton={true} // hide in case of MultiSubjects and JEE marking scheme
        isSummaryReportDisabled={isJeeMarkingScheme || isMultiSubjectAssessment}
        reportSubject={current_assessmemt_classStats?.assessment?.subjects.join(
          '_'
        )}
        reportClassName={current_assessmemt_classStats?.assessment?.class}
        reportSection={current_assessmemt_classStats?.assessment?.section}
      />
    </Box>
  );
};
